module.exports = __webpack_public_path__ + "img/English-11.6a20ed0c.jpg";